export const SIGNUP_URL = 'https://app.prio.ar/registrate';
